 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","addressEdit":"addressEdit","administratorAdd~customerAdd~customerEdit~offerAdd~offerEdit~orderEdit~promotionAdd~promotionEdit~su~0e3931be":"administratorAdd~customerAdd~customerEdit~offerAdd~offerEdit~orderEdit~promotionAdd~promotionEdit~su~0e3931be","administratorAdd":"administratorAdd","customerAdd":"customerAdd","customerDetail~offerDetail~promotionDetail~promotionEdit":"customerDetail~offerDetail~promotionDetail~promotionEdit","promotionAdd~promotionEdit":"promotionAdd~promotionEdit","promotionEdit":"promotionEdit","customerEdit":"customerEdit","offerAdd~offerEdit":"offerAdd~offerEdit","offerAdd":"offerAdd","offerEdit":"offerEdit","orderEdit":"orderEdit","promotionAdd":"promotionAdd","supplierProductDetail":"supplierProductDetail","administratorDetail":"administratorDetail","administratorEdit":"administratorEdit","administrators":"administrators","customerDetail~customers~offerDetail~orderDetail~supplierDetail~suppliers":"customerDetail~customers~offerDetail~orderDetail~supplierDetail~suppliers","customerDetail~orderDetail":"customerDetail~orderDetail","customerDetail":"customerDetail","offerDetail":"offerDetail","orderDetail":"orderDetail","customers":"customers","supplierDetail":"supplierDetail","suppliers":"suppliers","promotionDetail":"promotionDetail","dashboard":"dashboard","electricityCalculator":"electricityCalculator","emptyRouterView":"emptyRouterView","gasCalculator":"gasCalculator","giftAdd":"giftAdd","giftDetail":"giftDetail","giftEdit":"giftEdit","gifts":"gifts","home":"home","login":"login","messageAdd":"messageAdd","messageDetail":"messageDetail","messageEdit":"messageEdit","messages":"messages","notifications":"notifications","offers":"offers","passwordLost":"passwordLost","passwordReset":"passwordReset","passwordSetup":"passwordSetup","promotions":"promotions","settingDocusign":"settingDocusign","supplierEdit":"supplierEdit","supplierProductAdd":"supplierProductAdd","supplierProductEdit":"supplierProductEdit","users":"users"}[chunkId]||chunkId) + "." + {"404":"37e93c93","addressEdit":"909a2c3f","administratorAdd~customerAdd~customerEdit~offerAdd~offerEdit~orderEdit~promotionAdd~promotionEdit~su~0e3931be":"3f2e7122","administratorAdd":"4ace2217","customerAdd":"585928d6","customerDetail~offerDetail~promotionDetail~promotionEdit":"6ba96040","promotionAdd~promotionEdit":"0775ddab","promotionEdit":"3d86f7ed","customerEdit":"d16e3bb0","offerAdd~offerEdit":"8f45ef04","offerAdd":"1702809d","offerEdit":"f0cae176","orderEdit":"5f34ef22","promotionAdd":"16e13d10","supplierProductDetail":"acb25875","administratorDetail":"8184b49b","administratorEdit":"42803e23","administrators":"48476521","customerDetail~customers~offerDetail~orderDetail~supplierDetail~suppliers":"9d99dd14","customerDetail~orderDetail":"c75ebe49","customerDetail":"4991abf0","offerDetail":"fa3f7254","orderDetail":"afd29197","customers":"0ab2cff5","supplierDetail":"1190a206","suppliers":"7b51eb0c","promotionDetail":"fd92b2d9","dashboard":"c66282ea","electricityCalculator":"30481bd0","emptyRouterView":"8a3958b8","gasCalculator":"96ba525b","giftAdd":"f08016d1","giftDetail":"2687a2ea","giftEdit":"920cd63e","gifts":"c241c215","home":"ea8ee5b8","login":"e02e1c47","messageAdd":"6dd1f7ef","messageDetail":"fe7379a5","messageEdit":"a9b009d5","messages":"0311cc34","notifications":"cf5a9965","offers":"64e1d0ab","passwordLost":"4e0140da","passwordReset":"960e6f81","passwordSetup":"6da51c34","promotions":"800db1d7","settingDocusign":"c6cae852","supplierEdit":"3678de45","supplierProductAdd":"85684763","supplierProductEdit":"3e22ccaa","users":"130884ad"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"offerAdd~offerEdit":1,"customerDetail":1,"orderDetail":1,"electricityCalculator":1,"gasCalculator":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","addressEdit":"addressEdit","administratorAdd~customerAdd~customerEdit~offerAdd~offerEdit~orderEdit~promotionAdd~promotionEdit~su~0e3931be":"administratorAdd~customerAdd~customerEdit~offerAdd~offerEdit~orderEdit~promotionAdd~promotionEdit~su~0e3931be","administratorAdd":"administratorAdd","customerAdd":"customerAdd","customerDetail~offerDetail~promotionDetail~promotionEdit":"customerDetail~offerDetail~promotionDetail~promotionEdit","promotionAdd~promotionEdit":"promotionAdd~promotionEdit","promotionEdit":"promotionEdit","customerEdit":"customerEdit","offerAdd~offerEdit":"offerAdd~offerEdit","offerAdd":"offerAdd","offerEdit":"offerEdit","orderEdit":"orderEdit","promotionAdd":"promotionAdd","supplierProductDetail":"supplierProductDetail","administratorDetail":"administratorDetail","administratorEdit":"administratorEdit","administrators":"administrators","customerDetail~customers~offerDetail~orderDetail~supplierDetail~suppliers":"customerDetail~customers~offerDetail~orderDetail~supplierDetail~suppliers","customerDetail~orderDetail":"customerDetail~orderDetail","customerDetail":"customerDetail","offerDetail":"offerDetail","orderDetail":"orderDetail","customers":"customers","supplierDetail":"supplierDetail","suppliers":"suppliers","promotionDetail":"promotionDetail","dashboard":"dashboard","electricityCalculator":"electricityCalculator","emptyRouterView":"emptyRouterView","gasCalculator":"gasCalculator","giftAdd":"giftAdd","giftDetail":"giftDetail","giftEdit":"giftEdit","gifts":"gifts","home":"home","login":"login","messageAdd":"messageAdd","messageDetail":"messageDetail","messageEdit":"messageEdit","messages":"messages","notifications":"notifications","offers":"offers","passwordLost":"passwordLost","passwordReset":"passwordReset","passwordSetup":"passwordSetup","promotions":"promotions","settingDocusign":"settingDocusign","supplierEdit":"supplierEdit","supplierProductAdd":"supplierProductAdd","supplierProductEdit":"supplierProductEdit","users":"users"}[chunkId]||chunkId) + "." + {"404":"9881e7fd","addressEdit":"31d6cfe0","administratorAdd~customerAdd~customerEdit~offerAdd~offerEdit~orderEdit~promotionAdd~promotionEdit~su~0e3931be":"31d6cfe0","administratorAdd":"31d6cfe0","customerAdd":"31d6cfe0","customerDetail~offerDetail~promotionDetail~promotionEdit":"31d6cfe0","promotionAdd~promotionEdit":"31d6cfe0","promotionEdit":"31d6cfe0","customerEdit":"31d6cfe0","offerAdd~offerEdit":"502afd94","offerAdd":"31d6cfe0","offerEdit":"31d6cfe0","orderEdit":"31d6cfe0","promotionAdd":"31d6cfe0","supplierProductDetail":"31d6cfe0","administratorDetail":"31d6cfe0","administratorEdit":"31d6cfe0","administrators":"31d6cfe0","customerDetail~customers~offerDetail~orderDetail~supplierDetail~suppliers":"31d6cfe0","customerDetail~orderDetail":"31d6cfe0","customerDetail":"52dd74cc","offerDetail":"31d6cfe0","orderDetail":"878ed1f8","customers":"31d6cfe0","supplierDetail":"31d6cfe0","suppliers":"31d6cfe0","promotionDetail":"31d6cfe0","dashboard":"31d6cfe0","electricityCalculator":"5c46544c","emptyRouterView":"31d6cfe0","gasCalculator":"d28c3643","giftAdd":"31d6cfe0","giftDetail":"31d6cfe0","giftEdit":"31d6cfe0","gifts":"31d6cfe0","home":"31d6cfe0","login":"31d6cfe0","messageAdd":"31d6cfe0","messageDetail":"31d6cfe0","messageEdit":"31d6cfe0","messages":"31d6cfe0","notifications":"31d6cfe0","offers":"31d6cfe0","passwordLost":"31d6cfe0","passwordReset":"31d6cfe0","passwordSetup":"31d6cfe0","promotions":"31d6cfe0","settingDocusign":"31d6cfe0","supplierEdit":"31d6cfe0","supplierProductAdd":"31d6cfe0","supplierProductEdit":"31d6cfe0","users":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
